import React from "react";
import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import MxSelectCityField from "@rf-l1/form/selects/MxSelectCityField";
import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";

export type MxFormSelectCityFieldProp = Omit<MxAutoCompleteFieldProps, omit>

const MxFormSelectCityField = (props: MxFormSelectCityFieldProp) => {
  const { onChange, onBlur, name, value, invalid, id, testId, inputRef } =
    useMxFieldControllerContext();

  return (
    <MxSelectCityField
      {...props}
      id={id}
      testId={testId}
      inputRef={inputRef}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
};

export default MxFormSelectCityField;
